import { Application } from "stimulus"
import BlikPaymentController from "../controllers/blik_payment_controller"

const application = Application.start()
application.register("blik-payment", BlikPaymentController)
